// Waitlist opt-in stored as a boolean on the Art Event. The transition is
// one-way (false -> true) and is enforced by the backend; the UI mirrors that
// rule by locking the toggle once the Art Event has advanced.
export const DEFAULT_ART_EVENT_WAITLIST = false;
